export default __webpack_public_path__ + "static/media/loader.75842d86.gif";